import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';


export const CustomHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const authService = inject(AuthService);

  let authReq = null;
  const token = localStorage.getItem("access_token");
  if (token) {
    // Clone the request and add the authorization header
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  } else {
    authReq = req.clone();
  }

  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // Handle HTTP errors
        if (err.status === 401) {
          // Specific handling for unauthorized errors
          // alertService.display('error', "Unauthorized request");
          // authService.triggerLogin();
          authService.reset();
        } else {
          // Handle other HTTP error codes
          alertService.display('error', "An error has occured");
        }
      } else {
        // Handle non-HTTP errors
        alertService.display('error', "An unknown error has occured");
      }

      // Re-throw the error to propagate it further
      return throwError(() => err);
    }),
  );
};
